import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

/*
import { createRoot } from "react-dom/client";
import App from "./App";
import { StrictMode } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

// Create a functional component for the Landing Page
const LandingPage = () => {
    window.location.href = '/Landing.html'; // Redirect to the landing HTML page
    return null; // Return null since we are redirecting
};

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} /> 
      </Routes>
    </Router>
  </StrictMode>
);

*/